import { months } from "./dummy";
import { format } from "date-fns";

export function time_ago(date) {
    const formatDate = new Date(date).getTimezoneOffset() + 60 * 60 * 1000;
  
    var time = new Date(Date.now() - formatDate);
    //
    switch (typeof time) {
    case "number":
        break;
    case "string":
        time = +new Date(time);
        break;
    case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
    default:
        time = +new Date();
    }
    //
  
    var time_formats = [
        [60, "seconds", 1], // 60
        [120, "1 minute ago", "1 minute from now"], // 60*2
        [3600, "minutes", 60], // 60*60, 60
        [7200, "1 hour ago", "1 hour from now"], // 60*60*2
        [86400, "hours", 3600], // 60*60*24, 60*60
        [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
        [604800, "days", 86400], // 60*60*24*7, 60*60*24
        [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
        [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
        [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
        [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
        [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
  
    var seconds = (+new Date() - time) / 1000,
        token = "ago",
        list_choice = 1;
  
    if (seconds == 0) {
        return "Just now";
    }
    if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "from now";
        list_choice = 2;
    }
  
    var i = 0,
        format;
    while ((format = time_formats[i++]))
        if (seconds < format[0]) {
            if (typeof format[2] == "string") return format[list_choice];
            else
                return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
        }
  
    //
    return time;
}

export function formatDateRange(startDateStr, endDateStr) {
    if (!startDateStr) return "";
    
    // Parse ISO dates
    const startDate = new Date(startDateStr);
    const endDate = endDateStr ? new Date(endDateStr) : new Date();
            
    // Get day of week
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const dayOfWeek = weekdays[startDate.getDay()];
            
    // Get day of month
    const dayOfMonth = startDate.getDate();

    // Get year
    const year = startDate.getFullYear();
            
    // Get month
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[startDate.getMonth()];
                     
    // Format start and end times
    const startTime = formatTime(startDate);
    const endTime = formatTime(endDate);
            
    // Put it all together
    return `${dayOfWeek}, ${dayOfMonth} ${month} ${year} ⋅ ${startTime} – ${endTime}`;
}

export function splitExpiryDate(value) {
    // Try splitting with the standard forward slash
    let parts = value.split("/");

    // If the split didn't result in two parts, try splitting with the division slash
    if (parts.length !== 2) {
        parts = value.split("∕");
    }

    // If we still don't have two parts, or if either part is empty, return an empty array or handle as error
    if (parts.length !== 2 || parts.some(part => part.trim() === "")) {
        return []; // Or throw an error, or return a specific error value
    }

    // Parse the parts as integers
    return parts.map(numStr => parseInt(numStr.trim(), 10));
}

// Format time with AM/PM
function formatTime(date) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
                
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const formattedMinutes = minutes === 0 ? "" : ":" + (minutes < 10 ? "0" + minutes : minutes);
                
    return `${hours}${formattedMinutes}${ampm}`;
}

export function formatTimeToAmPm(isoTimeString) {
    const date = new Date(isoTimeString);
    
    return new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(date);
}

export function formatTimestampToTime(timestamp) {
    const date = new Date(timestamp);

    // Get hours in 24-hour format
    let hours = date.getUTCHours(); // Use getUTCHours() as the timestamp is in UTC ('Z' suffix)

    // Determine AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // The hour '0' should be '12 AM'

    // Return the formatted string
    return `${hours} ${ampm}`;
}

export function parseDateFromFilter(dateString) {
    const [day, month, year] = dateString.split("/").map(Number);
    return new Date(Date.UTC(year, month - 1, day));
}

export function getDateFromEnum(val, dueDate) {
    let date = dueDate ? new Date(dueDate) : new Date();
    let dueDateNo = undefined;

    if (!val) return undefined;
    const days = Number(val?.split("_")[0] || 7);

    switch (val) {
    case "30_days_before":
    case "21_days_before":
    case "14_days_before":
    case "7_days_before":
    case "3_days_before":
    case "1_day_before":
    case "on_due_date":
    case "1_day_after":
    case "3_days_after":
    case "7_days_after":
    case "14_days_after":
    case "21_days_after":
    case "30_days_after":
    case "60_days_after":
        date.setDate(date.getDate() - days);
        dueDateNo = date.getTime();
        break;

    default:
        break;
    }
	
    return dueDateNo;
}

export function extractDateFilters(val, dueDate) {
    let date = dueDate ? new Date(dueDate) : new Date();

    if (!val) return undefined;
    
    const year = new Date().getFullYear();

    switch (val) {
    case "7_days":
        date.setDate(date.getDate() - 7);
        return { startDate: date, endDate: new Date() };

    case "30_days":
        date.setDate(date.getDate() - 30);
        return { startDate: date, endDate: new Date() };

    case "1_year":
        return { startDate: new Date(`${year}-01-01`), endDate: new Date(`${year + 1}-01-01`) };

    case "today":
        return { startDate: date, endDate: new Date() };

    default:
        return undefined;
    }
}

/**
 * @param  {string} dateString: 2022-08-26T13:31:34.062Z
 * @returns {string} Fri 12 July 2024 3:02 PM
 */
export function formatDateStrings(dateString) { 
    if (!dateString) return "";
    
    const date = new Date(dateString);
    const pattern = "E dd MMMM yyyy h:mm a";

    return format(new Date(date), pattern);
}

export function getMonth(date, isConverted) {
    let d;

    if (date && !isConverted) {
        d = new Date(date);
    } else if (date && isConverted) {
        d = date;
    } else {
        d = new Date();
    }

    return months[d.getMonth()];
}

export function getMonthFromNum(num, subtract = true) {
    if (!num || typeof num !== "number") return "";

    const index = subtract ? num - 1 : num;

    return months[index];
}

export function extractInvoiceDateFilters(val) {
    if (!val) return undefined;

    let date = new Date();
    const day = Number(val?.split("_")[0] || 7);

    switch (val) {
    case "7_days":
    case "14_days":
    case "21_days":
    case "30_days":
    case "60_days":
    case "90_days":
        date.setDate(date.getDate() + day);
        break;

    default:
        return undefined;
    }

    return date;
}

export const getStoredTime = (key) => parseInt(sessionStorage.getItem(key) || "0", 10);